import React, { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { NoteTableControls } from "../note-table-controls/NoteTableControls";
import { TableAction, TableControlsState, TableMenuType } from "../note-table-controls/types";

interface NoteEditorProps {
    title: string;
    contentRef: RefObject<HTMLDivElement>;
    contentAreaRef: RefObject<HTMLDivElement>;
    tableControls: TableControlsState;
    onTitleChange: (value: string) => void;
    onTitleKeyDown: (event: React.KeyboardEvent) => void;
    onContentChange: () => void;
    onContentClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    onUpdateTableControls: (menu?: TableMenuType) => void;
    onTableAction: (action: TableAction) => void;
}

export const NoteEditor: React.FC<NoteEditorProps> = ({
    title,
    contentRef,
    contentAreaRef,
    tableControls,
    onTitleChange,
    onTitleKeyDown,
    onContentChange,
    onContentClick,
    onUpdateTableControls,
    onTableAction,
}) => {
    const { t } = useTranslation();

    return (
        <div className="note-modal-content-area" ref={contentAreaRef}>
            <input
                type="text"
                value={title}
                onKeyDown={onTitleKeyDown}
                onChange={(event) => onTitleChange(event.target.value)}
                placeholder={t("noteModal.enterNoteTitle")}
                className="note-modal-title-input"
            />
            <div
                ref={contentRef}
                contentEditable
                role="textbox"
                aria-multiline="true"
                data-placeholder={t("noteModal.enterNoteContent")}
                className="note-modal-input"
                onInput={onContentChange}
                onClick={onContentClick}
                onKeyUp={() => onUpdateTableControls()}
                onMouseUp={() => onUpdateTableControls(null)}
                onScroll={() => onUpdateTableControls()}
                onBlur={onContentChange}
            />
            <NoteTableControls
                controls={tableControls}
                onToggleMenu={onUpdateTableControls}
                onTableAction={onTableAction}
            />
        </div>
    );
};
